import { Settings } from "luxon";

declare module "luxon" {
  // eslint-disable-next-line no-unused-vars
  interface TSSettings {
    throwOnInvalid: true;
  }
}

export const initLuxon = (): void => {
  Settings.throwOnInvalid = true;
};
